import { TCheckinWidgetTypes } from 'interface'

type TThemes = Record<
  TCheckinWidgetTypes,
  {
    bgColor: string
    icon: 'checked' | 'enabled' | 'disabled'
    border?: 'dashed' | 'solid'
    borderColor?: string
  }
>
export const themes: TThemes = {
  CHECKED: {
    bgColor: 'var(--success100)',
    icon: 'enabled',
  },
  DISABLED: {
    bgColor: 'var(--neutral-theme)',
    icon: 'disabled',
    border: 'dashed',
    borderColor: 'var(--gray200)',
  },
  ENABLED: {
    bgColor: 'var(--gray100)',
    icon: 'enabled',
  },
  DAY_7_CHECKED: {
    bgColor: 'var(--success100)',
    icon: 'checked',
  },
  DAY_7_DISABLED: {
    bgColor: 'var(--neutral-theme)',
    icon: 'disabled',
    border: 'solid',
    borderColor: 'var(--gray200)',
  },
  DAY_7_ENABLED: {
    bgColor: 'var(--neutral-theme)',
    icon: 'enabled',
    border: 'solid',
    borderColor: 'var(--gray200)',
  },
}

export enum QueryKeys {
  CHECKIN_LIST = 'CHECKIN_LIST',
}
